"use strict"
function checkisSubscribedUser() {
  let subscribed = $.cookie('isSubscribedUser');

  if (subscribed == null || subscribed == 0) {
    $('#subscribe-wall').removeClass('d-none');
  } else {
    $('#subscribe-wall').addClass('d-none');
  };

  if (!$('#subscribe-wall').length || $('#subscribe-wall').hasClass('d-none')) {
    $('#articleAside').addClass('scroll');
  }
}
function validateEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

document.addEventListener("DOMContentLoaded", () => {
  checkisSubscribedUser();
  const subscribeWall = document.getElementById('subscribe-wall');
  const is_subscribe = document.getElementById('is_subscribe');
  const istn_subscribe = document.getElementById('istn_subscribe');

  let lastScroll = 0;
  let ticking = false;

  const updatePaywallPosition = (scrollY) => {
    if (subscribeWall) {
      if (scrollY > 1640 || window.innerWidth < 768) {
        subscribeWall.style.top = '0';
      } else {
        subscribeWall.style.top = (1640 - scrollY) + 'px';
      }
    }
  }

  const handlerScrollPaywall = () => {
    lastScroll = window.scrollY;

    if (!ticking) {
      window.requestAnimationFrame(function () {
        updatePaywallPosition(lastScroll);
        ticking = false;
      });

      ticking = true;
    }
  }

  handlerScrollPaywall();

  window.addEventListener('scroll', function () {
    handlerScrollPaywall();
  });

  $('#test_email').click(function () {
    let regex = validateEmail($('input[name=checkMail').val());

    console.log(regex);

    if (regex == false) {
      $('#checkMailMessage').text('Incorrect value');
    } else {
      $.post('/components/article/test-subscriber.php', {
        email: $('input[name=checkMail').val()
      }).done(
        function (data) {
          if (data == 'OK') {
            $.cookie("isSubscribedUser", "1", {
              path: '/', secure: true
            });
            checkisSubscribedUser();
          }
          else {
            $.cookie("isSubscribedUser", "0", {
              path: '/', secure: true
            });
            $('#checkMailMessage').text('Looks like you have not subscribed yet');
            checkisSubscribedUser();
          }
        }
      )
        .fail(
          function (data) {
            console.log('cant test email');
          }
        )
        .always(
          checkisSubscribedUser()
        )
        ;
    };
  });

  $('[data-fancybox="gallery"]').fancybox({
    infobar: false,
    caption: function (instance, item) {
      var caption = $(this).find('figaption').text() || '';

      return (caption.length ? caption + '<br />' : '') + 'Image <span data-fancybox-index></span> of <span data-fancybox-count></span>';
    }
  });

  const container = document.querySelector('.insights-row');
  let totalWidth = 0;

  const blocks = container.querySelectorAll('.insights-row__container .card');
  blocks.forEach(block => {
    totalWidth += block.offsetWidth;
  });

  // gap = 40
  totalWidth += 40 * (blocks.length - 1);

  if (totalWidth > container.offsetWidth) {
    const followUsSlider = new CustomSimpleSlider('.insights-row', '.insights-row__container', '.card');
  }

  $('#articleAside').attr('style', `padding-bottom: ${$('.article__subscription').outerHeight() + 10}px`);
  $('#articleAside').attr('style', `padding-top: ${$('.article__author').outerHeight() + 10}px`);
});